export default __webpack_public_path__ + "cb190ee771bcaee0ca56762092aa4c50.png";